export function noop<T>(arg: T): T {
	return arg
}
